export default {
    works(state) {
        return state.works;
    }
};